import { createFileRoute } from '@tanstack/react-router';

import { ReportPage } from '@/features/reports/reports-pages';

export const Route = createFileRoute('/_app/org/$orgId/reports/$reportKey')({
  component: CompanyReportRoute,
});

function CompanyReportRoute() {
  const { orgId, reportKey } = Route.useParams();
  return (
    <ReportPage
      scope={{ kind: 'org', id: orgId }}
      reportKey={reportKey}
      range={{}}
      onRange={() => undefined}
    />
  );
}
